import { Component, inject, Input } from '@angular/core';
import { Validators } from '@angular/forms';
import { CrudCreateComponent } from '../../../shared/components/crud/create/create.component';
import { FormField } from '../../../constants/form.constants';
// Debes crear ESTABLECIMIENTOS_FIELDS_FORM en tus constants
import { ESTABLECIMIENTOS_FIELDS_FORM } from '../../../constants/establecimientos.constants';
import { EstablecimientosService } from '../../../core/establecimientos.service';
import { ModalidadService } from '../../../core/modalidad.service';

@Component({
  selector: 'app-establecimientos-create',
  templateUrl: './establecimientos-create.component.html',
  styleUrls: ['./establecimientos-create.component.scss'],
  imports: [CrudCreateComponent],
})
export class EstablecimientosCreateComponent {
  fields: {[name: string]: FormField} = ESTABLECIMIENTOS_FIELDS_FORM;
  @Input() title: string = '';
  apiService = new EstablecimientosService();
  modalidadService = inject(ModalidadService);
  ngOnInit(){
    this.modalidadService.getAllForSelect().subscribe((data)=>{
      this.fields['modalidad_id'].options = data;
    });
  }
}
